import { appConfig as getAppConfig } from "../app.config";
import { productsClient } from "../lib/clients";
import { LoggerFactory } from "../utils/loggerFactory";
import LoginService from "./LoginService";

const log = LoggerFactory("ProductsAPI");

export const VISITOR_CONFIG = {
  center: null,
  perimetersLayer: ["bussola:municipios_perimetros"],
  pointsLayer: ["bussola:municipios_complexos_centroides_castanheiras"],
  polygonsLayer: ["bussola:complexos_castanheiras"],
};

const ProductsAPI = {
  async fetchDataByArea({ geojson, filters }) {
    const appConfig = await getAppConfig();

    return productsClient
      .post(
        `/calculate`,
        { geojson, filters },
        {
          headers: {
            Authorization: `Bearer ${LoginService.getAccessToken()}`,
            "x-app": appConfig?.slug ?? "",
          },
        }
      )
      .then((response) => {
        if (response.status === 200) return response.data;
        return null;
      })
      .catch((error) => {
        log("fetchDataByArea").error("{}", error.message ?? error);
        return null;
      });
  },

  async getRandomLocation() {
    return productsClient
      .get("/location/random", {
        headers: {
          Authorization: `Bearer ${LoginService.getAccessToken()}`,
        },
      })
      .then((response) => {
        if (response.status === 200) return response.data;
        return null;
      })
      .catch((error) => {
        log("getRandomLocation").error("{}", error.message ?? error);
        return null;
      });
  },

  async getCustomerBasedLayers(customerData) {
    if (LoginService.getMode() === "visitor") {
      return VISITOR_CONFIG;
    }

    const appConfig = await getAppConfig();

    const center = await this.getRandomLocation();

    let roles = customerData.roles?.split(",") ?? []
    if (roles.length === 0) {
      roles = customerData.permissions?.[customerData.currentLogin]?.map((p) => p.split(":")[0].toLowerCase()) ?? []
    }

    const perimetersLayer = roles.map(
      (role) =>
        `bussola:customer_app_perimeters_${role
          .toLowerCase()}`
    );

    const pointsLayer = roles.map(
      (role) =>
        `bussola:${appConfig?.slug ?? ""}_customer_app_points_${role
          .toLowerCase()}`
    );

    const polygonsLayer = roles.map(
      (role) =>
        `bussola:${appConfig?.slug ?? ""}_customer_app_polygons_${role
          .toLowerCase()}`
    );

    return {
      center: center ?? [-11.426638506524633, -61.948932695435424],
      perimetersLayer,
      pointsLayer,
      polygonsLayer,
    };
  },

  async getProductSizes() {
    return productsClient
      .get("/sizes", {
        headers: {
          Authorization: `Bearer ${LoginService.getAccessToken()}`,
        },
      })
      .then((response) => {
        if (response.status === 200) return response.data;
        return null;
      })
      .catch((error) => {
        log("getProductSizes").error("{}", error.message ?? error);
        return null;
      });
  },

  async generateReport(data) {
    return productsClient
      .post(`/reports`, data.content, {
        headers: {
          Authorization: `Bearer ${LoginService.getAccessToken()}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          const data = response.data;

          let report = Buffer.from(data, "base64");
          if (report.toString("utf-8").startsWith("%PDF")) {
            log("generateReport").error("local report generation");
          } else {
            report = Buffer.from(report.toString("utf-8"), "base64");
          }
          return new Blob([report]);
        }
        return null;
      })
      .catch((error) => {
        log("generateReport").error("{}", error.message ?? error);
        return null;
      });
  },

  async getCustomerDashBoard() {
    return productsClient
      .get("/companies/dashboard", {
        headers: {
          Authorization: `Bearer ${LoginService.getAccessToken()}`,
        },
      })
      .then((response) => {
        if (response.status === 200) return response.data;
        return null;
      })
      .catch((error) => {
        log("getCustomerDashBoard").error("{}", error.message ?? error);
        return null;
      });
  },

  async getPlacesByBBox(bbox) {
    return productsClient
      .get(`/places?bbox=${bbox}`, {
        headers: {
          Authorization: `Bearer ${LoginService.getAccessToken()}`,
        },
      })
      .then((response) => {
        if (response.status === 200) return response.data;
        return null;
      })
      .catch((error) => {
        log("getPlacesByBBox").error("{}", error.message ?? error);
        return null;
      });
  },
};

export default ProductsAPI;
